"use client";

import React from "react";
import { Wrench, ShieldCheck, CreditCard } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const logos = [{
  id: 1,
  name: "Uber",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/uber_logo_monochrome.png"
}, {
  id: 2,
  name: "Lyft",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/lyft_logo_monochrome.png"
}, {
  id: 3,
  name: "DoorDash",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/doordash_logo_monochrome.png"
}, {
  id: 4,
  name: "Insurance Partner",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/insurance_partner_logo_monochrome.png"
}];
const badges = [{
  id: 1,
  title: "24/7 Maintenance",
  description: "Keep earning without downtime. We handle all routine maintenance and emergency repairs to keep you on the road.",
  icon: Wrench
}, {
  id: 2,
  title: "Fully Insured",
  description: "Drive with complete peace of mind. Comprehensive rideshare and delivery insurance is included with every rental.",
  icon: ShieldCheck
}, {
  id: 3,
  title: "No Credit Check",
  description: "Get approved and on the road faster. We qualify you based on your active gig platform profile, not your credit score.",
  icon: CreditCard
}];
export default function DriverTrustSignals() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="driver-trust-signals" className="bg-background py-16 md:py-24 overflow-hidden" ref={ref}>
      <div className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 lg:gap-24 mb-16 md:mb-24">
          {logos.map((logo, i) => <div key={logo.id} data-index={i} className="flex items-center justify-center opacity-50 grayscale transition-all duration-300 hover:opacity-80 hover:grayscale-0">
              <img src={logo.src} alt={`${logo.name} logo`} className="h-8 md:h-10 lg:h-12 w-auto object-contain" />
            </div>)}
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {badges.map((badge, i) => {
          const Icon = badge.icon;
          return <Card key={badge.id} data-index={i} className="group border-border/50 bg-card/50 backdrop-blur-sm transition-all duration-300 hover:shadow-lg hover:shadow-primary/5 hover:border-primary/20">
                <div className="px-6 pt-8">
                  <div className="size-14 rounded-2xl bg-primary/10 flex items-center justify-center text-primary transition-all duration-300 group-hover:bg-primary/20 group-hover:scale-110 group-hover:animate-pulse">
                    <Icon className="size-7" strokeWidth={1.5} />
                  </div>
                </div>
                <CardHeader className="pt-6 pb-8">
                  <CardTitle className="text-xl font-semibold tracking-tight text-foreground">
                    {badge.title}
                  </CardTitle>
                  <CardDescription className="text-base leading-relaxed text-muted-foreground mt-2">
                    {badge.description}
                  </CardDescription>
                </CardHeader>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}